import { createActions, createReducer } from "reduxsauce";
export const { Types, Creators } = createActions({
    buscarRemetentes: ["payload"],
    buscarRemetentesNovo: ["payload"],
    buscarRemetentesSucesso: ["payload"],
    buscarRemetentesSucessoNovo: ["payload"],
    setRemetenteSelecionado: ["payload"],
    setLoadingRemetentes: ["payload"]
});

const INIT_STATE = {
    remetentesLista: [],
    remetentesListaNova: [],
    alertMessage: "",
    remetenteSelecionado: [],
    loadingRemetentes: false,
    showMessage: false
};

const buscarRemetentesSucesso = (state = INIT_STATE, action) => ({
    ...state,
    remetentesLista: action.payload,
    loadingRemetentes: false
});
const buscarRemetentesSucessoNovo = (state = INIT_STATE, action) => ({
    ...state,
    remetentesListaNova: action.payload,
    loadingRemetentes: false
});
const setRemetenteSelecionado = (state = INIT_STATE, action) => ({
    ...state,
    remetenteSelecionado: action.payload
});
const setLoadingRemetentes = (state = INIT_STATE, action) => ({
    ...state,
    loadingRemetentes: action.payload.loader
});

export default createReducer(INIT_STATE, {
    [Types.BUSCAR_REMETENTES_SUCESSO]: buscarRemetentesSucesso,
    [Types.BUSCAR_REMETENTES_SUCESSO_NOVO]: buscarRemetentesSucessoNovo,
    [Types.SET_REMETENTE_SELECIONADO]: setRemetenteSelecionado,
    [Types.SET_LOADING_REMETENTES]: setLoadingRemetentes
});
